import { ApolloError, gql, useMutation } from '@apollo/client';
import { getSmsPreferencesByCountry } from './queries';

export const updateSmsPreferencesMutation = gql`
  mutation updateSmsPreferences(
    $regionCode: String!
    $numericOptOut: String!
    $alphanumericOptOut: String!
    $frequency: SmsDisclaimerType!
  ) {
    smsPreferencesUpdate(
      regionCode: $regionCode
      optOutText: $numericOptOut
      alphanumericOptOutText: $alphanumericOptOut
      frequency: $frequency
    ) {
      regionName
    }
  }
`;

/** Update project SMS preferences for a specific country */
export const useMutationUpdateSmsPreferences = (
  onComplete: () => void,
  onError: (e: ApolloError | Error) => void,
) => {
  const [updateSmsPreferences, { data, loading, error }] = useMutation(
    updateSmsPreferencesMutation,
    {
      onCompleted: (response) => {
        const { regionName } = response.smsPreferencesUpdate;
        if (regionName) onComplete();
        else onError(new Error('Response did not return expected field'));
      },
      onError,
      refetchQueries: [{ query: getSmsPreferencesByCountry }],
    },
  );

  return {
    updateSmsPreferences,
    data,
    loading,
    errorMessage: error?.message || data?.smsPreferencesUpdate?.failure?.message,
  };
};
